import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errorMessage } from "../lib/api";
import { useLang } from "../lib/i18n";
import { InsightsView } from "../components/insights/InsightsView";
import { RangeSelect } from "../components/insights/RangeSelect";

export default function Insights() {
  const { t } = useLang();
  const [days, setDays] = useState(30);
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/me/insights", { params: { days } }).then(({ data }) => setData(data)).catch((e) => toast.error(errorMessage(e)));
  }, [days]);

  return (
    <div className="space-y-8" data-testid="insights-page">
      <div className="flex flex-wrap items-end gap-4">
        <div className="me-auto">
          <h1 className="font-display text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">{t("insights")}</h1>
          <p className="mt-2 text-sm text-slate-500">{t("ins_note")}</p>
        </div>
        <RangeSelect value={days} onChange={setDays} />
      </div>
      {data ? <InsightsView data={data} /> : <div className="h-96 animate-pulse rounded-3xl bg-slate-200" />}
    </div>
  );
}
